import api, { learningGroupsApi } from "./index";

export interface LearningGroupParams {
  companyId: string;
  ids?: Array<string>;
  responsibleId?: string;
  courseId?: string;
  title?: string;
  registrationsIds?: Array<string>;
  registrationsUserIds?: Array<string>;
  educationStartedAtMin?: Date;
  educationStartedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "title" | "educationStartedAt" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: LearningGroupParams, options?: any) => {
  return learningGroupsApi.Group.listLearningGroup(
    params.companyId,
    params.ids,
    params.responsibleId,
    params.courseId,
    params.title,
    params.registrationsIds,
    params.registrationsUserIds,
    params.educationStartedAtMin,
    params.educationStartedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
